import React from 'react'
import { Stack } from '@mui/material'
import NoticesSectionsContainer from './NoticesSectionsContainer'
import { useNoticesContext } from './NoticesContext'

export default function PopupNoticesContainer() {
    const { notices } = useNoticesContext()

    if (notices == null || notices.length === 0) {
        return null
    }

    return (
        <Stack
            data-testid="popup-notices"
            direction="column"
            gap={1}
            mb={2}
        >
            <NoticesSectionsContainer notices={notices} />
        </Stack>
    )
}
